export enum TagsEvents {
  TagCreated = 'tags.TagCreated',
  TagRemoved = 'tags.TagRemoved'
}
